module.exports = __webpack_public_path__ + "static/media/join-in-img8-2.f1a25cbe.png";